export const configurationTabs = {
  'Create campaign': 'createCampaign',
  'Create sport bonus': 'CreateSportBonus',
  'Email templates': 'EmailTemplates',
  'Bonus status': 'BonusesStatus'
};
